<template>
    <section class="position-relative px-0">
        <div
            class="container mw-100 border-gray mobile-tile mb-0 bg-white"
            :class="isSelected ? 'selected-tile' : ''"
        >
            <div class="col-12 px-0 bg-header-tile">
                <div class="row">
                    <!--/* PICTO 5G */-->
                    <img
                        v-if="offer.showPicto5G"
                        class="logo-5g"
                        :src="offer.picto5gSrc"
                        alt=""
                    >

                    <!--/* BANNIERE + TIMER */-->
                    <div v-if="offer.banner" class="col-10 pb-2">
                        <div class="col-auto p-0">
                            <div class="row align-items-center mobile-banner">
                                <!--/* BANNER */-->
                                <div class="col-auto p-0 padding-bottom-banner">
                                    <div class="ob1-tag ob1-tag-primary">
                                        <span>{{ offer.banner }}</span>
                                    </div>
                                </div>
                                <!--/* TIMER */-->
                                <div
                                    v-if="offer.timerEndDateInMilliseconds"
                                    class="col-auto p-0 padding-left-tag padding-bottom-banner"
                                >
                                    <timer
                                        :end-date-in-milliseconds="offer.timerEndDateInMilliseconds"
                                        :color="offer.countDownColor ? offer.countDownColor : 'text-dark'"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-12 pb-2">
                        <div class="mobile-banner" />
                    </div>

                    <!--/* OFFRE */-->
                    <div class="col-12">
                        <div class="title-align">
                            <div class="h4 text-dark pb-1 mb-0">
                                {{ offer.name }}
                            </div>
                        </div>
                    </div>

                    <!--/* PRIX */-->
                    <div class="col-12">
                        <Price
                            class="mobileprice-align"
                            :price="offer.price.price"
                            :initial-price="offer.price.initialPrice"
                            :price-details="offer.price.priceDetails ? offer.price.priceDetails : undefined"
                            :show-from="offer.price.showFrom"
                            :show-by-month="offer.price.showByMonth"
                            :show-promo-duration="offer.price.showPromoDuration"
                            :show-promo-duration-first-months="offer.price.showPromoDurationFirstMonths"
                            :show-children-promotion-price="offer.price.showChildrenPromotionPrice"
                            :duration="offer.price.duration"
                            :is-cents-format="false"
                            :is-compact="offer.price.compact"
                        />
                    </div>

                    <!--/* PROMO REMISE OPEN */-->
                    <div class="col-12 pb-1">
                        <div class="mobile-promo">
                            <div
                                v-if="offer.discountLabel"
                                class="bg-greige p-1 d-flex align-items-center justify-content-center"
                            >
                                <span
                                    class="alert-icon icon-phone-fund-euro text-primary font-size-28 me-1"
                                    aria-hidden="true"
                                />
                                <span class="ob1-alert-title fw-bold">{{ formattedDiscountLabel }}</span>
                            </div>
                        </div>
                    </div>

                    <!--/* LIEN FICHE DETAIL OFFRE */-->
                    <div v-if="offer.foLink" class="col-12">
                        <a
                            :href="offer.foLink"
                            class="ob1-link-arrow"
                            :data-oevent-category="offer.foTms.category"
                            :data-oevent-action="offer.foTms.action"
                            :data-oevent-label="offer.foTms.label"
                        >Découvrir cette offre</a>
                    </div>

                    <!--/* SELECTION */-->
                    <div class="col-12 p-1">
                        <div v-if="isSelected" class="mobile-selection h-100">
                            <span class="mb-0 d-flex border-top-bottom-2 align-items-center justify-content-center h-100">
                                <span class="icon icon-tick-circle" style="font-size: 1.5rem" aria-hidden="true" />
                                <span class="lead fw-bold ms-1" v-text="buttonLabel" />
                            </span>
                        </div>
                        <div v-else class="mobile-selection d-flex flex-column">
                            <button
                                class="btn btn-secondary"
                                style="padding-left: 0; padding-right: 0;"
                                type="button"
                                :data-oevent-category="offer.selectButtonTms.category"
                                :data-oevent-action="offer.selectButtonTms.action"
                                :data-oevent-label="offer.selectButtonTms.label"
                                @click="onSelectOffer()"
                                v-text="buttonLabel"
                            />
                        </div>
                    </div>
                    <!--/* ATTRIBUTES + CLAIMS */-->
                    <div class="col-12">
                        <!--/* ATTRIBUTES */-->
                        <div
                            v-for="(attribute, attributeIndex) in offer.attributes"
                            :key="'attribute-without-update-'+attributeIndex"
                            class="mobile-attributes"
                        >
                            <div class="d-flex align-items-center pb-1">
                                <div class="flex-shrink-0 mobile-attribute-image me-1">
                                    <span
                                        class="icon lead text-primary"
                                        :class="(attribute.image) ? attribute.image : 'icon-tick'"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div class="flex-grow-1">
                                    <div
                                        class="font-size-14"
                                        v-html="attribute.description"
                                    />
                                </div>
                            </div>
                        </div>
                        <!--/* CLAIMS */-->
                        <div v-if="offer.claims" class="mobile-attributes">
                            <ul class="row list-unstyled">
                                <li v-for="(claim, index) in offer.claims">
                                    <offer-claim :key="index" :claim="claim" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import Price from "../../../../../../common/components/ob1/Price.vue";
import OfferClaim from "../../../../../../fmfmo/common/vitrine/OfferClaim.vue";

export default {
    name: "MobileOfferTile",
    components: {OfferClaim, Price},
    props: {
        offer: {type: Object, required: true},
        selectedMobileOfferSeoId: {type: String, default: false}
    },
    computed: {
        formattedDiscountLabel() {
            return this.offer.discountLabel ? this.handleBreakingSpaces(this.offer.discountLabel) : undefined
        },
        buttonLabel() {
            if (this.isSelected) {
                return this.offer.selectedButtonLabel
            } else return this.offer.selectButtonLabel;
        },
        isSelected() {
            return this.offer.seoId === this.selectedMobileOfferSeoId
        }
    },
    methods: {
        onSelectOffer() {
            this.$emit('select-offer', this.offer.seoId);
        },
        handleBreakingSpaces(str) {
            return str.replace('&nbsp;', '\xa0');
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_colors';
@import 'ob1_common';
@import 'ob1_variables';

.border-gray {
    border: px-to-rem(2) solid $gray-lighter;
}

.selected-tile {
    border: 0.0625rem solid $brand-orange;
    box-shadow: 0.125rem 0.125rem $brand-orange;
}

.logo-5g {
    position: absolute;
    top: 1px;
    right: -14px;
    width: 23%;
}

.padding-bottom-banner {
    padding-bottom: 5px !important;
}

.padding-left-tag {
    padding-left: 10px !important;
}

.border-top-bottom-2 {
    border-top: px-to-rem(2) solid $gray-lighter;
    border-bottom: px-to-rem(2) solid $gray-lighter;
}

.mobile-selection .btn {
    max-width: none;
}

.mobile-attribute-image {
    min-width: 16px;
    min-height: 16px;
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        min-width: 18px;
        min-height: 18px;
    }
}
</style>
